import { Field, Formik, FieldArray } from "formik";
import React, { useEffect, useState } from "react";
import "../../../../assets/css/cms/Coaching.css";
import "../../../../assets/css/cms/Article.css";
import "../../../../assets/css/cms/Newsletter.css";
import { Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { required, number } from "../../../../utils/validations";
import CustomEditor5 from "../../../../utils/ckEditor5";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getCmsCoachingCourse,
  getCmsCoachingSubjects,
  getCmsCoachingExams,
  UpdateCmsCoachingCourse,
  getCmsCoachingName,
  postCmsCoachingCourse,
  DeleteCmsCoachingCourse,
  postCmsCoachingCoursePublish,
  getCmsCoaching,
} from "../../../../../store/actions/cms/cmsCoaching";
import { Alert, getCardActionAreaUtilityClass } from "@mui/material";
import CommonModal from "../../../utils/commonModal";
import { AiFillWarning } from "react-icons/ai";

const CoachingCoursesForm = (props) => {
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({});

  const [examOptions, setExamOptions] = React.useState([]);
  const [examInput, setExamInput] = useState("");

  const [subjectOptions, setSubjetOptions] = useState([]);
  const [subjectInput, setSubjectInput] = useState("");

  const [debounceState, setDebounceState] = useState(false);
  const [saveAndNext, setSaveAndNext] = useState(false);
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { id, courseId } = useParams();

  const {
    coachingSubjects,
    coachingExams,
    coachingName,
    course,
    post_cms_coaching_course_success,
    message,
    post_cms_coaching_course_failure,
    update_cms_coaching_course_failure,
    post_cms_coaching_course_loading
  } = useSelector((state) => state?.cmsCoaching);
  const user = useSelector((state) => state?.userData?.user?.data);

  const durationOptions = Array.from(Array(61).keys())
    ?.map((key) => {
      return { id: key, value: key, label: key };
    })
    ?.slice(1);

  useEffect(() => {
    if (post_cms_coaching_course_success?.id) {
      navigate(
        `/cms/coaching/${id}/coaching-courses/${post_cms_coaching_course_success?.id}/course`
      );
    }
  }, [post_cms_coaching_course_success]);

  const learningModeOptions = [
    { label: "Online", value: "1" },
    { label: "Classroom", value: "2" },
    { label: "Hybrid", value: "3" },
  ];

  useEffect(() => {
    if (courseId) {
      dispatch(getCmsCoachingCourse({ coaching_id: id, course_id: courseId }));
    } else {
      setInitialValues({
        product_offering_description: <div></div>,
        description: <div></div>,
        eligibility_description: <div></div>,
      });
    }
    dispatch(getCmsCoachingExams({ exam_name: "" }))
    dispatch(getCmsCoachingName({ coaching_id: id }));
    dispatch(getCmsCoachingSubjects({ subject_query: "" }))
    return () => {
      dispatch({ type: "CLEAR_COACHING_COURSE" });
      setTimeout(() => {
        dispatch({ type: "CLEAR_COACHING_COURSE" });
        dispatch({ type: "CLEAR_UPDATE_CMS_COACHING_COURSE" });
        dispatch({ type: "CLEAR_POST_CMS_COACHING_COURSE" });
      }, 2000);
    };
  }, []);
  const onSearch = (value, type) => {
    let inDebounce = debounceState;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => {
      if (type == "exam" && examInput !== value) {
        setExamInput(value);
        dispatch(getCmsCoachingExams({ exam_name: value }));
      } else if (type == "subject" && subjectInput !== value) {
        setSubjectInput(value);
        dispatch(getCmsCoachingSubjects({ subject_query: value }));
      }
    }, 1000);
    setDebounceState(inDebounce);
  };

  useEffect(() => {
    if (coachingExams?.data?.length) {
      setExamOptions(coachingExams?.data);
    }
  }, [coachingExams]);

  useEffect(() => {
    if (coachingSubjects?.data?.subject_data?.length) {
      setSubjetOptions(coachingSubjects?.data?.subject_data);
    }
  }, [coachingSubjects]);

  useEffect(() => {
    dispatch(getCmsCoaching({ coaching_id: id }))
  }, [])
  const { coaching } = useSelector((state) => state.cmsCoaching)

  useEffect(() => {
    if (course?.items?.length > 0) {
      let newvalues = {
        masterCoachingName: coachingName?.coaching_name,
        courseName: course?.items?.[0]?.name ?? "",
        courseExam: course?.items?.[0]?.exams,
        courseSubject: course?.items?.[0]?.subjects,
        courseDuration: durationOptions?.find(
          (obj) => obj.id == course?.items?.[0]?.duration
        ),
        updated_on: course?.items?.[0]?.updated_on,
        updated_by_name: course?.items?.[0]?.updated_by_name,
        modeofLearning:
          learningModeOptions?.find(
            (obj) => obj.value == course?.items?.[0]?.mode_id
          ) ?? null,
        courseSession: course?.items?.[0]?.session,
        product_offering_description: course?.items?.[0]
          ?.product_offering_description ?? <div></div>,
        description: course?.items?.[0]?.description ?? <div></div>,
        eligibility_description: course?.items?.[0]
          ?.eligibility_description ?? <div></div>,
        published: course?.items?.[0]?.published,
        published_by_name: course?.items?.[0]?.published_by_name,
        published_at: course?.items?.[0]?.published_at,
      };
      setInitialValues(newvalues);
    } else if (course?.items?.length == 0) {
      navigate(`/cms/coaching/${id}/coaching-courses/course`);
    }
  }, [course]);

  return (
    <div>
      <div className={"notification_popup"}>
        {message && (
          <Alert
            severity={
              post_cms_coaching_course_failure ||
                update_cms_coaching_course_failure
                ? `error`
                : `success`
            }
          >
            {" "}
            {message}{" "}
          </Alert>
        )}
      </div>
      <div className="d-flex">
        <a href={`/cms/coaching/${id}/coaching-courses`}><h4 className={"news_letter_heading"}>Coaching Courses &nbsp;</h4></a>
        <h4 className={"news_letter_heading text-dark"}>/ &nbsp;Coaching Course Info</h4>
      </div>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validate={(values) => {
          const errors = {};
          if (!values.courseName) {
            errors.courseName = required(values.courseName);
          }
          if (!values.courseDuration) {
            errors.courseDuration = required(values.courseDuration);
          }
          // if (number(values?.courseSession)) {
          //   errors.courseSession = number(values?.courseSession);
          // }
          if (!values.courseSubject) {
            errors.courseSubject = required(values.courseSubject);
          }
          return errors;
        }}
        onSubmit={(values) => {
          let params = {};
          // params.coaching_id = id;
          params.course_id = courseId;
          let body = {};
          body.name = values?.courseName;
          body.coaching_id = id;
          body.exam_list = values?.courseExam?.map(
            (examId, index) => examId.exam_id
          ) || []
          body.subject_list = values?.courseSubject.map(
            (subjectId, index) => subjectId.id
          );
          body.duration = values?.courseDuration?.value;
          body.mode = values?.modeofLearning?.value;
          body.session = values?.courseSession;
          body.description =
            typeof values?.description === "string"
              ? values?.description
              : null;
          body.eligibility_description =
            typeof values?.eligibility_description === "string"
              ? values?.eligibility_description
              : null;
          body.product_offering_description =
            typeof values?.product_offering_description === "string"
              ? values?.product_offering_description
              : null;
          if (courseId) {
            body.updated_by = user?.id;
            dispatch(UpdateCmsCoachingCourse(params, body));
          } else {
            body.created_by = user?.id;
            dispatch(postCmsCoachingCourse(body));
          }
          if (saveAndNext) {
            setSaveAndNext(false);
            navigate(`/cms/coaching/${id}/coaching-institute`);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className={"basic_details_coaching"}>
              <div className={"examfilter"}>
                <h5 className="mb-3">Basic Details of Master Coaching</h5>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="masterCoachingName">
                      <Form.Label>Master Coaching Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="masterCoachingName"
                        className={"input_pd"}
                        value={coachingName?.coaching_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="courseName">
                      <Form.Label>Course Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="courseName"
                        className={"input_pd"}
                        value={values.courseName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isMulti={true}
                      />
                      {errors.courseName && touched.courseName && (
                        <div className="error">{errors.courseName}</div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="courseExam">
                      <Form.Label>Course Exam</Form.Label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="courseExam"
                        getOptionLabel={(option) => option.exam_name}
                        getOptionValue={(option) => option.exam_short_name}
                        value={values.courseExam}
                        onBlur={handleBlur}
                        isMulti={true}
                        onChange={(selectedOption) => {
                          let event = {
                            target: {
                              name: "courseExam",
                              value: selectedOption,
                            },
                          };
                          handleChange(event);
                        }}
                        isClearable={true}
                        options={examOptions}
                        isSearchable={true}
                        onInputChange={(value) => onSearch(value, "exam")}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="courseSubject">
                      <Form.Label>Course Subject *</Form.Label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="courseSubject"
                        options={subjectOptions}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.name}
                        value={values.courseSubject}
                        isMulti={true}
                        onBlur={() =>
                          handleBlur({ target: { name: "courseSubject" } })
                        }
                        onChange={(selectedOption) => {
                          let event = {
                            target: {
                              name: "courseSubject",
                              value: selectedOption,
                            },
                          };
                          handleChange(event);
                        }}
                        isClearable={true}
                        onInputChange={(value) => onSearch(value, "subject")}
                      />
                      {errors.courseSubject && touched.courseSubject && (
                        <div className="error">{errors.courseSubject}</div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Row>
                      <Col sm={8}>
                        <Form.Group className="mb-3" controlId="courseDuration">
                          <Form.Label>Course Duration *</Form.Label>
                          <Select
                            className="basic-single"
                            classNamePrefix="select"
                            name="courseDuration"
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            value={values.courseDuration}
                            onBlur={() =>
                              handleBlur({ target: { name: "courseDuration" } })
                            }
                            onChange={(selectedOption) => {
                              let event = {
                                target: {
                                  name: "courseDuration",
                                  value: selectedOption,
                                },
                              };
                              handleChange(event);
                            }}
                            isClearable={true}
                            options={durationOptions}
                          />
                          {errors.courseDuration && touched.courseDuration && (
                            <div className="error">{errors.courseDuration}</div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col sm={4}>
                        <span className={"months_duration"}>months</span>
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="modeofLearning">
                      <Form.Label>Mode of Learning</Form.Label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="modeofLearning"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        value={values.modeofLearning}
                        onBlur={handleBlur}
                        onChange={(selectedOption) => {
                          let event = {
                            target: {
                              name: "modeofLearning",
                              value: selectedOption,
                            },
                          };
                          handleChange(event);
                        }}
                        isClearable={true}
                        options={learningModeOptions}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={4}>
                    <Form.Group className="mb-3" controlId="courseSession">
                      <Form.Label>Course Session</Form.Label>
                      <Form.Control
                        type="text"
                        name="courseSession"
                        className={"input_pd"}
                        value={values.courseSession}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.courseSession && touched.courseSession && (
                        <div className="error">{errors.courseSession}</div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                {values.description && (
                  <Row className="mt-5">
                    <Form.Group className="mb-3" controlId="description">
                      <Form.Label>Course Description :</Form.Label>
                      <CustomEditor5
                        initData={values.description}
                        onChange={(event) => {
                          setFieldValue(
                            "description",
                            event || <div></div>
                          );
                        }}
                      />
                    </Form.Group>
                  </Row>
                )}
                {values.eligibility_description && (
                  <Row className="mt-5">
                    <Form.Group
                      className="mb-3"
                      controlId="eligibility_description"
                    >
                      <Form.Label>Eligibility Description :</Form.Label>
                      <CustomEditor5
                        initData={values.eligibility_description}
                        onChange={(event) => {
                          setFieldValue(
                            "eligibility_description",
                            event || <div></div>
                          );
                        }}
                      />
                    </Form.Group>
                  </Row>
                )}

                {values.product_offering_description && (
                  <Row className="mt-5">
                    <Form.Group
                      className="mb-3"
                      controlId="product_offering_description"
                    >
                      <Form.Label>Product Offering Description :</Form.Label>
                      <CustomEditor5
                        initData={values.product_offering_description}
                        onChange={(event) => {
                          setFieldValue(
                            "product_offering_description",
                            event || <div></div>
                          );
                        }}
                      />
                    </Form.Group>
                  </Row>
                )}
                <Row>
                  {id && (
                    <span className="mt-4">
                      Last Updated date :{initialValues?.updated_on}{" "}
                    </span>
                  )}
                </Row>
                <Row>
                  {id && (
                    <span className="mt-2">
                      Updated by: {initialValues?.updated_by_name}{" "}
                    </span>
                  )}
                </Row>
                {((initialValues?.published_at || initialValues?.published_by_name) && initialValues?.published) &&
                  <>
                    <Row>
                      <span className="mt-4">
                        Published Date :{initialValues?.published_at}{" "}
                      </span>
                    </Row>
                    <Row>
                      <span className="mt-2">
                        Published by: {initialValues?.published_by_name}{" "}
                      </span>
                    </Row>
                  </>
                }
              </div>
            </div>

            <Row>
              <Col className="mt-4">
                <button className={`${"exam_button"} ${post_cms_coaching_course_loading ? 'pe-none opacity-50' : ''}`} type="submit">
                  Save
                </button>
                <button
                  className={`${"exam_button"}`}
                  type="submit"
                  onClick={() => {
                    Object.entries(errors)?.length === 0 &&
                      setSaveAndNext(true);
                  }}
                >
                  Save & Next
                </button>
                {courseId &&
                  <>
                    <button
                      className={`${"exam_button"}`}

                      onClick={() => setOpen(true)}
                      type="submit"
                    >
                      Delete
                    </button>
                    {coaching?.coaching[0]?.published &&
                      <>
                        <button className="exam_button" onClick={() => navigate(`/cms/coaching/${id}/coaching-courses/${courseId}/course/publish`)}>{values?.published ? "Publish Updates" : "Publish"}</button>
                        {values?.published && <button className="exam_button" onClick={() => navigate(`/cms/coaching/${id}/coaching-courses/${courseId}/course/unpublish`)}>Unpublish</button>}
                      </>
                    }
                  </>
                }
              </Col>
            </Row>
            <CommonModal
              isOpen={open}
              closeModal={() => {
                setOpen(false);
              }}
            >
              {
                values?.published ?
                  <div>
                    <div className="text_edit">
                      <AiFillWarning className="text-warning" />{" "}
                      To delete coaching course you need to unpublish it first
                    </div>
                    <div className="icon_buttons">
                      <button className="icon_edits icon_no_color" onClick={() => setOpen(false)}>
                        {" "}
                        Ok
                      </button>
                    </div>
                  </div>
                  :
                  <div className="delete_confirmation">
                    <div className="text_edit"> Are you sure want to delete <span className="master_coaching_text_edit">{values.courseName}</span>?</div>
                    <div className="icon_buttons">
                      <button
                        className="icon_edits icon_yes_color"
                        onClick={() => {
                          setOpen(false);
                          navigate(`/cms/coaching/${id}/coaching-courses/${courseId}/course/delete`)
                        }}
                      >
                        Yes
                      </button>
                      <button className="icon_edits icon_no_color" onClick={() => setOpen(false)}>
                        {" "}
                        No
                      </button>
                    </div>
                  </div>

              }

            </CommonModal>
          </form>
        )}
      </Formik>
    </div >
  );
};

export default CoachingCoursesForm;
